import * as Sentry from "@sentry/react";

if (import.meta.env.VITE_SENTRY_ENABLED === "true") {
  const releaseId = import.meta.env.VITE_RELEASE_ID || new Date().toISOString();

  Sentry.init({
    dsn: import.meta.env.VITE_SENTRY_DSN,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration({
        maskAllText: false,
        blockAllMedia: false,
      }),
    ],
    tracesSampleRate: 1.0,
    replaysSessionSampleRate: 1.0,
    replaysOnErrorSampleRate: 1.0,
    release: releaseId,
    environment: import.meta.env.VITE_RELEASE_DEPLOY_ENVIRONMENT,
  });
}

export const captureException = (error: unknown, description: string) => {
  console.error(description, error);
  Sentry.captureException(error, { extra: { description } });
};

export const captureErrorMessage = (message: string) => {
  console.error(message);
  Sentry.captureMessage(message, "error");
};

window.__sentry = Sentry;

